import { render, staticRenderFns } from "./InvestmentAccountTypeLink.vue?vue&type=template&id=684f06d8&scoped=true"
import script from "./InvestmentAccountTypeLink.vue?vue&type=script&lang=ts"
export * from "./InvestmentAccountTypeLink.vue?vue&type=script&lang=ts"
import style0 from "./InvestmentAccountTypeLink.vue?vue&type=style&index=0&id=684f06d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684f06d8",
  null
  
)

export default component.exports